module.exports = __webpack_public_path__ + "img/double-bounty-icon.b1450ce2.png";